var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69531 13.1406C7.9375 13.1406 9.10156 12.7656 10.0703 12.125L13.4922 15.5547C13.7188 15.7734 14.0078 15.8828 14.3203 15.8828C14.9688 15.8828 15.4453 15.375 15.4453 14.7344C15.4453 14.4375 15.3438 14.1484 15.125 13.9297L11.7266 10.5156C12.4297 9.51562 12.8438 8.30469 12.8438 6.99219C12.8438 3.60938 10.0781 0.84375 6.69531 0.84375C3.32031 0.84375 0.546875 3.60938 0.546875 6.99219C0.546875 10.375 3.3125 13.1406 6.69531 13.1406ZM6.69531 11.5C4.21875 11.5 2.1875 9.46875 2.1875 6.99219C2.1875 4.51562 4.21875 2.48438 6.69531 2.48438C9.17188 2.48438 11.2031 4.51562 11.2031 6.99219C11.2031 9.46875 9.17188 11.5 6.69531 11.5ZM4.67969 7.60938H8.71094C9.04688 7.60938 9.32812 7.32812 9.32812 6.99219C9.32812 6.65625 9.04688 6.375 8.71094 6.375H4.67969C4.34375 6.375 4.0625 6.65625 4.0625 6.99219C4.0625 7.32812 4.34375 7.60938 4.67969 7.60938Z",
    fill: "#908CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomOut);
export default __webpack_public_path__ + "static/media/icon-zoom-out.811bd4381198c98e2121d19ce0198e5a.svg";
export { ForwardRef as ReactComponent };